export default __webpack_public_path__ + "static/media/mg-3-rMIN.65a484fc.avif";